(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function formatMoney(cents) {
    const formatString = window.shopMoneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formatted = formatString.replace(/\{\{\s*\w+\s*\}\}/g, formattedValue);
    return formatted.replace(/<[^>]*>/g, '').trim();
  }

  function parseEndDate(raw) {
    if (!raw) return null;
    const normalized = raw.trim().replace(/\//g, '-').replace(' ', 'T');
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function getCurrentVariant() {
    const product = window.ShopifyProduct;
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return null;

    const variantId = variantInput ? parseInt(variantInput.value, 10) : NaN;
    if (Number.isFinite(variantId)) {
      return product.variants.find((variant) => Number(variant.id) === variantId) || null;
    }

    return product.variants.find((variant) => variant.available) || product.variants[0] || null;
  }

  function updateSalePrice() {
    const priceEl = document.querySelector('[data-sale-price]');
    if (!priceEl) return;

    const discount = Number(window.bfDiscount || 0);
    if (!Number.isFinite(discount) || discount <= 0) return;

    const variant = getCurrentVariant();
    if (!variant) return;

    const discountCents = Math.round(discount * 100);
    const saleCents = Math.max(0, Number(variant.price) - discountCents);
    priceEl.textContent = formatMoney(saleCents);
  }

  function initCountdown(root) {
    const endDate = parseEndDate(root.dataset.endDate);
    const display = root.querySelector('[data-countdown-display]');
    if (!endDate || !display) return;

    const daysEl = display.querySelector('[data-countdown-days]');
    const hoursEl = display.querySelector('[data-countdown-hours]');
    const minutesEl = display.querySelector('[data-countdown-minutes]');
    const secondsEl = display.querySelector('[data-countdown-seconds]');

    function tick() {
      const diff = endDate.getTime() - Date.now();
      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-promo-countdown]').forEach(initCountdown);
    updateSalePrice();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, updateSalePrice);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
